import Ticker from "../components/Ticker";

const TopRight = ({ gameData }) => {
  if (!gameData) return null;

  const renderPass = () =>
    (gameData?.Goals || []).map((goal, i) => {
      const isHome = goal.team === gameData.HomeTeam.short;
      const teamLogo = isHome ? gameData.HomeTeam.logo : gameData.AwayTeam.logo;
      const assistants = [
        goal.assistByPlayer1?.lastName,
        goal.assistByPlayer2?.lastName,
      ].filter(Boolean);
      return (
        <span
          key={`g-${i}`}
          className="mx-3 flex items-center gap-1 whitespace-nowrap py-0.5 text-3xl"
        >
          {goal.timeMinute && (
            <span className="text-gray-300">{goal.timeMinute}'</span>
          )}
          <img
            src={teamLogo}
            alt={goal.team}
            className="mx-1 h-8 w-8 object-contain"
          />
          <span className="text-white">
            {goal.shotByPlayer?.lastName}
          </span>
          {assistants.length > 0 && (
            <span className="ml-2 text-gray-400 font-light">({assistants.join(", ")})</span>
          )}
          <span className="ml-2 font-number text-white">
            {goal.scoreHome}:{goal.scoreAway}
          </span>
        </span>
      );
    });

  return (
    <div className="flex min-h-[56px] w-full items-center overflow-hidden rounded-bl-lg bg-gray-700 px-3 font-exo-two">
      <Ticker>{renderPass()}</Ticker>
    </div>
  );
};

export default TopRight;
